import { createSlice } from '@reduxjs/toolkit';
import * as yup from 'yup';
import { DateStringSchema, EmailArraySchema, EmailSchema, KoodiSchema, PostinumeroSchema, PostiosoiteSchema, PuhelinnumeroSchema, } from './yupSchemas';
const initialState = {};
const organisationSlice = createSlice({
    name: 'organisation',
    initialState,
    reducers: {
        setForm: (state, action) => {
            state.form = action.payload;
        },
        setInitialOrganisation: (state, action) => {
            state.initialOrganisation = action.payload;
        },
    },
});
export default organisationSlice.reducer;
export const { setForm, setInitialOrganisation } = organisationSlice.actions;
export const OrganisationSchema = (yritysmuodot, kunnat, postinumerot) => yup.object().shape({
    yritysmuoto: KoodiSchema(yritysmuodot),
    kotipaikka: KoodiSchema(kunnat),
    alkamisaika: DateStringSchema,
    puhelinnumero: PuhelinnumeroSchema,
    email: EmailSchema,
    emails: EmailArraySchema,
    postiosoite: PostiosoiteSchema.required(),
    postinumero: PostinumeroSchema(postinumerot).required(),
    copyKayntiosoite: yup.bool().required(),
    kayntiosoite: yup
        .string()
        .when('copyKayntiosoite', ([copyKayntiosoite], schema) => copyKayntiosoite ? schema.optional() : PostiosoiteSchema.required()),
    kayntipostinumero: yup
        .string()
        .when('copyKayntiosoite', ([copyKayntiosoite], schema) => copyKayntiosoite ? schema.optional() : PostinumeroSchema(postinumerot).required()),
});
